import React, { FC, ReactNode } from 'react';
import { Col, Row, Switch } from 'antd';
import { Field, FieldProps, useFormikContext } from 'formik';
import { SwitchChangeEventHandler, SwitchProps } from 'antd/lib/switch';
import styles from './switchComponent.module.scss';
import { SwitchLabelPosition } from 'enums/FieldTypeEnums';

export interface SwitchComponentProps extends SwitchProps {
  name: string;
  checked?: boolean;
  onChange?: SwitchChangeEventHandler;
  disabled?: boolean;
  label?: ReactNode;
  labelPosition?: SwitchLabelPosition;
}

const SwitchComponent: FC<SwitchComponentProps> = props => {
  const {
    name,
    checked,
    onChange,
    label,
    labelPosition = SwitchLabelPosition.LEFT,
    ...remainingProps
  } = props;

  const { setFieldValue } = useFormikContext();

  const isLeftLabel = label && labelPosition === SwitchLabelPosition.LEFT;

  const switchLabel = <Col className={styles.label}>{label}</Col>;

  const handleChange: SwitchChangeEventHandler = (checked, e) => {
    const { target } = e;
    if (name) {
      setFieldValue(name, checked);
      onChange?.(checked, e);
    }
  };

  return (
    <Field name={name}>
      {({ field }: FieldProps) => (
        <Row align="middle" gutter={[5, 10]}>
          {isLeftLabel ? switchLabel : null}
          <Col>
            <Switch
              {...remainingProps}
              checked={checked !== undefined ? checked : field.value ?? false}
              onChange={handleChange}
            />
          </Col>
          {!isLeftLabel ? switchLabel : null}
        </Row>
      )}
    </Field>
  );
};

export default SwitchComponent;
